import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon} from "@ui5/webcomponents-react";
import { Box, Typography } from "@mui/material";

const InvoiceStatusDistributionCardApproved = ({ invoiceData }) => {
  const [loading, setLoading] = useState(true);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [initiatedCount, setInitiatedCount] = useState(0);
  const [notApprovedCount, setNotApprovedCount] = useState(0);

  useEffect(() => {
    const calculateApprovedCount = () => {
      if (!invoiceData || invoiceData.length === 0) {
        setTotalInvoices(0);
        setApprovedCount(0);
        setInitiatedCount(0);
        setNotApprovedCount(0);
        setLoading(false);
        return;
      }

      let approved = 0;
      let initiated = 0;
      let notApproved = 0;

      invoiceData.forEach((invoice) => {
        if (invoice.status === "Approved") {
          approved++;
        } else if (invoice.status !== "Approved" && invoice.status !== "Pending") {
          initiated++;
        } else {
          notApproved++;
        }
      });
      

      setTotalInvoices(invoiceData.length);
      setApprovedCount(approved);
      setInitiatedCount(initiated);
      setNotApprovedCount(notApproved);
      setLoading(false);
    };

    calculateApprovedCount();
  }, [invoiceData]);

  return (
    <>
      {/* Invoice Status Distribution Card */}
     

      <Card
        square
        header={<CardHeader avatar={<Icon name="validate" />} subtitleText={`Out of ${totalInvoices}`} titleText="Invoice Status Approved" />}
      >
        <Box display="flex" justifyContent="right"  sx={{ mr: 2, mb: 2 }}>
          <Typography variant="h5"  style={{ fontWeight: 'bold', color: 'grey', fontSize: 45, fontFamily: 'SapFiori72' }}> {approvedCount}</Typography>
        </Box>
      </Card>

      <Card
        square
        header={<CardHeader avatar={<Icon name="in-progress" />} subtitleText={`Out of ${totalInvoices}`} titleText="Invoice Status Initiated" />}
      >
        <Box display="flex" justifyContent="right"  sx={{ mr: 2, mb: 2 }}>
          <Typography variant="h5"  style={{ fontWeight: 'bold', color: 'grey', fontSize: 45, fontFamily: 'SapFiori72' }}>{initiatedCount}</Typography>
        </Box>
      </Card>
	  
      <Card
        square
        header={<CardHeader avatar={<Icon name="pending" />} subtitleText={`Out of ${totalInvoices}`} titleText="Invoice Status Pending" />}
      >
        <Box display="flex" justifyContent="right"  sx={{ mr: 2, mb: 2 }}>
          <Typography variant="h5"  style={{ fontWeight: 'bold', color: 'grey', fontSize: 45, fontFamily: 'SapFiori72' }}>{notApprovedCount}</Typography>
        </Box>
      </Card>

    </>
  );
};

export default InvoiceStatusDistributionCardApproved;
